import { useContext } from 'react';
import { ClientsContext } from '../ClientsContext';

export function useClient(clientId: number) {
  const clients = useClients();
  return clients.find(client => client.id === clientId);
}

export function useClients() {
  const clients = useContext(ClientsContext);
  return clients.filter(client => !client.inactive);
}

export function useAllClients() {
  return useContext(ClientsContext);
}
